module.exports = __webpack_public_path__ + "static/media/skeletonCoffee.3f9d4a8f.gif";